import { CenteredMessagePage } from "@components/ui/CenteredMessagePage"
import { useRoutePageContext } from "@components/ui/route-page-context"
import * as m from "@paraglide/messages"

export function ErrorPage() {
  const { locale } = useRoutePageContext()
  return (
    <CenteredMessagePage
      testId="page-error"
      title={m.error_404_label({}, { locale: locale })}
      linkHref="/"
      linkLabel={m.back_toHome({}, { locale: locale })}
    >
      <p>{m.error_404_description({}, { locale: locale })}</p>
    </CenteredMessagePage>
  )
}
